import { Environment } from './Environment.model'

const apiDomain = `https://${process.env.REACT_APP_ROOT_API_DOMAIN}.adminsite.ai`

export const environment: Environment = {
  production: false,
  devTool: true,
  apiUrl: {
    root: apiDomain as string,
    asset: `${apiDomain}/asset`,
    // asset: `http://localhost:3000/dev`,
    client: `${apiDomain}/client`,
    // client: `http://localhost:3000/dev`,
    contact: `${apiDomain}/security/contact`,
    // contact: `http://localhost:3000/dev/contact`,
    contract: `${apiDomain}/contract`,
    // contract: `http://localhost:3000/dev`,
    task: `${apiDomain}/helpdesk/task`,
    // task: `http://localhost:3000/dev/task`,
    ticket: `${apiDomain}/helpdesk/ticket`,
    // ticket: `http://localhost:3000/dev/ticket`,
    media: `${apiDomain}/media`,
    report: `${apiDomain}/report`,
    // report: `http://localhost:3000/dev`,
    security: `${apiDomain}/security`,
    user: `${apiDomain}/security/user`,
    // user: `http://localhost:3000/dev/user`,
  },
  routes: {
    home: '/dashboard/home',
    login: '/sign-in',
  },
  storage: {
    maxSizeAllowed: 26214400, //25MB
  },
  localStorage: {
    auth: {
      idTokenKey: 'idToken',
      tokenTypeKey: 'tokenType',
      expiresInKey: 'expiresIn',
      accessTokenKey: 'accessToken',
      refreshTokenKey: 'refreshToken',
    },
    i18nKey: process.env.REACT_APP_LOCAL_STORAGE_KEY_I18N || 'i18n',
    theme: {
      modeKey: process.env.REACT_APP_LOCAL_STORAGE_KEY_THEME_MODE || 'kt_theme_mode_value',
      menuModeKey: process.env.REACT_APP_LOCAL_STORAGE_KEY_THEME_MENU_MODE || 'kt_theme_mode_menu',
    },
    layoutConfig: process.env.REACT_APP_LOCAL_STORAGE_KEY_LAYOUT_CONFIG || 'kt_layout_config',
  },
  i18n: {
    default: 'es',
  },
}